import { CANDIDACY_TYPE, CREDIT_TYPE, CURRENT_CAREER, FINAL_EXAM_TYPE, PROFESSIONAL_EXAM_TYPE, GRAD_LEVEL } from "./constants";
import {formDataEnum} from "./formDataEnum";


export const formData = formDataEnum;
export const inputMappings = {
  inputGroup: "inputGroup",
  numberInput: "numberInput",
  textInput: "textInput",
  dropDown: "dropDown",
  checkbox: "checkbox",
  radio: "radio",
  subheading: "subheading",
  lookup: "lookup",
  approverLookup: "approverLookup",
  fileUpload: "fileUpload",
  date: "date",
  time: "time",
  datetime: "datetime",
  phone: "phone",
  street: "street",
  email: "email"
};

export const loggedinUserData = {
  cumUndergradGpa: 'cumUndergradGpa',
  mailingAddress: 'mailingAddress'
}

export const dropdownSubtypes = {
  graduatePrograms: "graduatePrograms",
  proposedGraduatePrograms: "proposedGraduatePrograms",
  facultyRank: "facultyRank",
  graduationLevel: "graduationLevel",
  term: "term", // SIS
  advisor: "advisor",
  coAdvisor: "coAdvisor",
  facultyMember: "facultyMember",
  finalDocumentLevels: "finalDocumentLevels",
  finalExamLevels: "finalExamLevels",
  designationMinor: "designationMinor",
  designationGIS: "designationGIS",
  careerType: "careerType",
  creditType: "creditType",
  certicatePlans: "certicatePlans",
  specialization: "specialization",
  academicUnit: "academicUnit",
  degrees: "degrees",
  gfnDegrees: "gfnDegrees",
  candidacyType: "candidacyType",
  examType: "examType", 
  examReason: "examReason",
  gradFacultyRepresentative: "gradFacultyRepresentative",
  proposedAdvisor: "proposedAdvisor",
  gradPlanAdminPrograms: "gradPlanAdminPrograms",
  professionalExamType: "professionalExamType",
  searchTerms: "searchTerms"
}

export const asyncOptions = [
  dropdownSubtypes.graduatePrograms,
  dropdownSubtypes.proposedGraduatePrograms,
  dropdownSubtypes.term,
  dropdownSubtypes.degrees,
  dropdownSubtypes.gfnDegrees,
  dropdownSubtypes.certicatePlans,
  dropdownSubtypes.specialization,
  dropdownSubtypes.designationMinor,
  dropdownSubtypes.designationGIS,
  dropdownSubtypes.academicUnit,
  dropdownSubtypes.facultyRank,
  dropdownSubtypes.gradPlanAdminPrograms,
  dropdownSubtypes.searchTerms
]

export const debouncedOptions = [
  dropdownSubtypes.advisor,
  dropdownSubtypes.coAdvisor,
  dropdownSubtypes.facultyMember,
  dropdownSubtypes.gradFacultyRepresentative,
  dropdownSubtypes.proposedAdvisor
]

export const graduateFacultyOptions = [
  dropdownSubtypes.advisor,
  dropdownSubtypes.coAdvisor,
  dropdownSubtypes.facultyMember,
  dropdownSubtypes.gradFacultyRepresentative,
  dropdownSubtypes.proposedAdvisor
];

export const graduationlevels = [
  {
    title: "Doctoral",
    value: "Doctoral",
    id: "doctoral",
    match: null
  },
  {
    title: "DMA",
    value: "DMA",
    id: "dma",
    match: null
  },
  {
    title: "Educ Specialist",
    value: "Educational Specialist",
    id: "educ-specialist",
    match: null
  },
  {
    title: "Master's - Candidacy Exam",
    value: "Master_CE",
    id: "ma-candidacy-exam",
    match: "Master"
  },
  {
    title: "Master's - Non-thesis",
    value: "Master_NT",
    id: "ma-non-thesis",
    match: "Master"
  },
  {
    title: "Master's - Thesis",
    value: "Master_T",
    id: "ma-thesis",
    match: "Master"
  },
  {
    title: "Master's - Course Based",
    value: "MasterCB",
    id: "ma-course-based",
    match: null
  },
  {
    title: "Professional",
    value: "Professional",
    id: "professional",
    match: null
  }
]

export const finalDocumentLevels = graduationlevels.filter(({ value }) => {
  return [
    "DMA",
    "Doctoral",
    "Master_T"
  ].includes(value)
})

export const finalExamLevels = graduationlevels.filter(({ value }) => {
  return [
    "DMA",
    "Doctoral",
  ].includes(value)
})

export const synchronousOptions = {
  [dropdownSubtypes.graduationLevel]: graduationlevels,
  [dropdownSubtypes.finalDocumentLevels]: finalDocumentLevels,
  [dropdownSubtypes.finalExamLevels]: finalExamLevels,
  [dropdownSubtypes.careerType]: [
    {
      id: 'undergraduate',
      title: 'Undergraduate',
      value: CURRENT_CAREER.UNDERGRAD,
    },
    {
      id: 'Graduate',
      title: 'Graduate',
      value: CURRENT_CAREER.GRAD
    },
    {
      id: 'Professional',
      title: 'Professional',
      value: CURRENT_CAREER.PROF
    }
  ],
  [dropdownSubtypes.creditType]: [
    {
      id: 'graduate-non-degree',
      title: 'Graduate Non-degree',
      value: CREDIT_TYPE.GRADNONDEGREE
    },
    {
      id: 'outside-institution-transfer-courses',
      title: 'Outside Institution - Transfer Individual Courses',
      value: CREDIT_TYPE.OUTSIDE_TRANSFER_COURSES
    },
    {
      id: 'outside-institution-transfer-masters-degree',
      title: 'Outside Institution - Transfer Master\'s Degree (Block of 30)',
      value: CREDIT_TYPE.OUTSIDE_TRANSFER_MASTERS_DEGREE
    },
    {
      id: 'previous-osu-masters-degree',
      title: 'Previous OSU Master\'s Degree',
      value: CREDIT_TYPE.PREVIOUS_OSU_MASTERS_DEGREE
    },
    {
      id: 'senior-petition',
      title: 'Senior Petition',
      value: CREDIT_TYPE.SENIORPETITION
    }
  ],
  [dropdownSubtypes.candidacyType]: [ 
    { 
      id: 'first', 
      title: 'First Candidacy', 
      value: CANDIDACY_TYPE.FIRST_CANDIDACY, 
    },  
    { 
      id: 'second', 
      title: 'Second Candidacy', 
      value: CANDIDACY_TYPE.SECOND_CANDIDACY 
    }, 
    { 
      id: 'supplemental', 
      title: 'Supplemental Candidacy', 
      value: CANDIDACY_TYPE.SUPPLEMENTAL_CANDIDACY 
    } 
  ], 
  [dropdownSubtypes.examType]: [ 
    { 
      id: 'first', 
      title: 'First Final Exam', 
      value: FINAL_EXAM_TYPE.FIRST_FINAL_EXAM, 
    }, 
    { 
      id: 'second', 
      title: 'Second Final Exam', 
      value: FINAL_EXAM_TYPE.SECOND_FINAL_EXAM 
    } 
  ], 
  [dropdownSubtypes.examReason]: [ 
    { 
      id: 'reason1', 
      title: 'Semester Extension', 
      value: 'SEMESTER_EXTENSION', 
    }, 
    { 
      id: 'reason2', 
      title: 'Rule Waiver', 
      value: 'RULE_WAIVER' 
    }, 
    { 
      id: 'reason3', 
      title: 'Non OSU Graduate Faculty', 
      value: 'NON_OSU_GRADUATE_FACULTY' 
    }, 
    { 
      id: 'reason4', 
      title: 'Former OSU Graduate Faculty', 
      value: 'FORMER_OSU_GRADUATE_FACULTY' 
    }, 
    { 
      id: 'reason5', 
      title: 'Video Conference', 
      value: 'VIDEO_CONFERENCE' 
    }, 
    { 
      id: 'reason6', 
      title: 'Other', 
      value: 'OTHER' 
    } 
  ],
  [dropdownSubtypes.professionalExamType]: [ 
    { 
      id: 'first', 
      title: 'First Professional Exam', 
      value: PROFESSIONAL_EXAM_TYPE.FIRST_PROFESSIONAL_EXAM, 
    }, 
    { 
      id: 'second', 
      title: 'Second Professional Exam', 
      value: PROFESSIONAL_EXAM_TYPE.SECOND_PROFESSIONAL_EXAM 
    } 
  ],  
  [dropdownSubtypes.eosOption]: [ 
    { 
      id: 'option1', 
      title: 'Yes', 
      value: true, 
    }, 
    { 
      id: 'option2', 
      title: 'No', 
      value: false 
    } 
  ],
  [dropdownSubtypes.gfnDegrees]: [
    {
      id: "degree-dma-1",
      group: "DMA",
      selectedTitle: "DMA - DMA",
      title: "    DMA",
      value: "DMA"
    },
    {
      id: "degree-doctoral-1",
      group: "Doctoral",
      selectedTitle: "Doctoral - DNS",
      title: "    DNS",
      value: "DNS"
    },
    {
      id: "degree-doctoral-2",
      group: "Doctoral",
      selectedTitle: "Doctoral - PHD",
      title: "    PHD",
      value: "PHD"
    },
    {
      id: "degree-doctoral-3",
      group: "Doctoral",
      selectedTitle: "Doctoral - SCD",
      title: "    SCD",
      value: "SCD"
    },
    {
      id: "degree-master-1",
      group: "Master",
      selectedTitle: "Master - MA",
      title: "    MA",
      value: "MA"
    },
    {
      id: "degree-master-2",
      group: "Master",
      selectedTitle: "Master - MACPR",
      title: "    MACPR",
      value: "MACPR"
    },
    {
      id: "degree-master-3",
      group: "Master",
      selectedTitle: "Master - MACQRMGT",
      title: "    MACQRMGT",
      value: "MACQRMGT"
    },
    {
      id: "degree-master-4",
      group: "Master",
      selectedTitle: "Master - MAPPAERO",
      title: "    MAPPAERO",
      value: "MAPPAERO"
    },
    {
      id: "degree-master-5",
      group: "Master",
      selectedTitle: "Master - MASATHTR",
      title: "    MASATHTR",
      value: "MASATHTR"
    },
    {
      id: "degree-master-6",
      group: "Master",
      selectedTitle: "Master - MASDENHY",
      title: "    MASDENHY",
      value: "MASDENHY"
    },
    {
      id: "degree-master-7",
      group: "Master",
      selectedTitle: "Master - MASMTHSC",
      title: "    MASMTHSC",
      value: "MASMTHSC"
    },
    {
      id: "degree-master-8",
      group: "Master",
      selectedTitle: "Master - MBA",
      title: "    MBA",
      value: "MBA"
    },
        {
      id: "degree-master-9",
      group: "Master",
      selectedTitle: "Master - MBOE",
      title: "    MBOE",
      value: "MBOE"
    },        
    {
      id: "degree-master-10",
      group: "Master",
      selectedTitle: "Master - MCR",
      title: "    MCR",
      value: "MCR"
    },        
    {
      id: "degree-master-11",
      group: "Master",
      selectedTitle: "Master - MDIETNTR",
      title: "    MDIETNTR",
      value: "MDIETNTR"
    },
    {
      id: "degree-master-12",
      group: "Master",
      selectedTitle: "Master - MENR",
      title: "    MENR",
      value: "MENR"
    }, 
    {
      id: "degree-master-13",
      group: "Master",
      selectedTitle: "Master - MFA",
      title: "    MFA",
      value: "MFA"
    }, 
    {
      id: "degree-master-14",
      group: "Master",
      selectedTitle: "Master - MGLBENGL",
      title: "    MGLBENGL",
      value: "MGLBENGL"
    },
    {
      id: "degree-master-15",
      group: "Master",
      selectedTitle: "Master - MPA",
      title: "    MPA",
      value: "MPA"
    }, 
    {
      id: "degree-master-16",
      group: "Master",
      selectedTitle: "Master - MPAL",
      title: "    MPAL",
      value: "MPAL"
    },
    {
      id: "degree-master-17",
      group: "Master",
      selectedTitle: "Master - MPH",
      title: "    MPH",
      value: "MPH"
    },
    {
      id: "degree-master-18",
      group: "Master",
      selectedTitle: "Master - MPHM",
      title: "    MPHM",
      value: "MPHM"
    },
    {
      id: "degree-master-19",
      group: "Master",
      selectedTitle: "Master - MRT",
      title: "    MRT",
      value: "MRT"
    },
    {
      id: "degree-master-20",
      group: "Master",
      selectedTitle: "Master - MS",
      title: "    MS",
      value: "MS"
    },
    {
      id: "degree-master-21",
      group: "Master",
      selectedTitle: "Master - MSARCST",
      title: "    MSARCST",
      value: "MSARCST"
    },
    {
      id: "degree-master-22",
      group: "Master",
      selectedTitle: "Master - MSDENHY",
      title: "    MSDENHY",
      value: "MSDENHY"
    },
    {
      id: "degree-master-23",
      group: "Master",
      selectedTitle: "Master - MSPCOACH",
      title: "    MSPCOACH",
      value: "MSPCOACH"
    },
    {
      id: "degree-master-24",
      group: "Master",
      selectedTitle: "Master - MSTACCTG",
      title: "    MSTACCTG",
      value: "MSTACCTG"
    },
    {
      id: "degree-master-25",
      group: "Master",
      selectedTitle: "Master - MSTAHR",
      title: "    MSTAHR",
      value: "MSTAHR"
    },
    {
      id: "degree-master-26",
      group: "Master",
      selectedTitle: "Master - MSTANSCI",
      title: "    MSTANSCI",
      value: "MSTANSCI"
    },
    {
      id: "degree-master-27",
      group: "Master",
      selectedTitle: "Master - MSTAPLEC",
      title: "    MSTAPLEC",
      value: "MSTAPLEC"
    },
    {
      id: "degree-master-28",
      group: "Master",
      selectedTitle: "Master - MSTAPLNS",
      title: "    MSTAPLNS",
      value: "MSTAPLNS"
    },
    {
      id: "degree-master-29",
      group: "Master",
      selectedTitle: "Master - MSTAPLST",
      title: "    MSTAPLST",
      value: "MSTAPLST"
    },
    {
      id: "degree-master-30",
      group: "Master",
      selectedTitle: "Master - MSTBLENG",
      title: "    MSTBLENG",
      value: "MSTBLENG"
    },
    {
      id: "degree-master-31",
      group: "Master",
      selectedTitle: "Master - MSTCTENG",
      title: "    MSTCTENG",
      value: "MSTCTENG"
    },
    {
      id: "degree-master-32",
      group: "Master",
      selectedTitle: "Master - MSTEDU",
      title: "    MSTEDU",
      value: "MSTEDU"
    },
    {
      id: "degree-master-33",
      group: "Master",
      selectedTitle: "Master - MSTHLADM",
      title: "    MSTHLADM",
      value: "MSTHLADM"
    },
    {
      id: "degree-master-34",
      group: "Master",
      selectedTitle: "Master - MSTLARCH",
      title: "    MSTLARCH",
      value: "MSTLARCH"
    },
    {
      id: "degree-master-35",
      group: "Master",
      selectedTitle: "Master - MSTLHR",
      title: "    MSTLHR",
      value: "MSTLHR"
    },
    {
      id: "degree-master-36",
      group: "Master",
      selectedTitle: "Master - MSTMUSIC",
      title: "    MSTMUSIC",
      value: "MSTMUSIC"
    },
    {
      id: "degree-master-37",
      group: "Master",
      selectedTitle: "Master - MSTOCCTH",
      title: "    MSTOCCTH",
      value: "MSTOCCTH"
    },
    {
      id: "degree-master-38",
      group: "Master",
      selectedTitle: "Master - MSTREGPL",
      title: "    MSTREGPL",
      value: "MSTREGPL"
    },
    {
      id: "degree-master-39",
      group: "Master",
      selectedTitle: "Master - MSTRHRM",
      title: "    MSTRHRM",
      value: "MSTRHRM"
    },
    {
      id: "degree-master-40",
      group: "Master",
      selectedTitle: "Master - MSTSTLAW",
      title: "    MSTSTLAW",
      value: "MSTSTLAW"
    },
    {
      id: "degree-master-41",
      group: "Master",
      selectedTitle: "Master - MSTSWK",
      title: "    MSTSWK",
      value: "MSTSWK"
    },
    {
      id: "degree-master-42",
      group: "Master",
      selectedTitle: "Master - MTDA",
      title: "    MTDA",
      value: "MTDA"
    },
    {
      id: "degree-master-43",
      group: "Master",
      selectedTitle: "Master - SMBUS",
      title: "    SMBUS",
      value: "SMBUS"
    },
    {
      id: "degree-professional-1",
      group: "Professional",
      selectedTitle: "Professional - AUD",
      title: "    AUD",
      value: "AUD"
    },
    {
      id: "degree-professional-2",
      group: "Professional",
      selectedTitle: "Professional - DDS",
      title: "    DDS",
      value: "DDS"
    },
    {
      id: "degree-professional-3",
      group: "Professional",
      selectedTitle: "Professional - DO",
      title: "    DO",
      value: "DO"
    },
    {
      id: "degree-professional-4",
      group: "Professional",
      selectedTitle: "Professional - DNE",
      title: "    DNE",
      value: "DNE"
    },
    {
      id: "degree-professional-5",
      group: "Professional",
      selectedTitle: "Professional - DNP",
      title: "    DNP",
      value: "DNP"
    },
    {
      id: "degree-professional-6",
      group: "Professional",
      selectedTitle: "Professional - DPT",
      title: "    DPT",
      value: "DPT"
    },
    {
      id: "degree-professional-7",
      group: "Professional",
      selectedTitle: "Professional - EDD",
      title: "    EDD",
      value: "EDD"
    },
    {
      id: "degree-professional-8",
      group: "Professional",
      selectedTitle: "Professional - EDD",
      title: "    EDD",
      value: "EDD"
    },
    {
      id: "degree-professional-9",
      group: "Professional",
      selectedTitle: "Professional - DFA",
      title: "    DFA",
      value: "DFA"
    },
    {
      id: "degree-professional-10",
      group: "Professional",
      selectedTitle: "Professional - DVM",
      title: "    DVM",
      value: "DVM"
    },
    {
      id: "degree-professional-11",
      group: "Professional",
      selectedTitle: "Professional - JD",
      title: "    JD",
      value: "JD"
    },
    {
      id: "degree-professional-12",
      group: "Professional",
      selectedTitle: "Professional - MD",
      title: "    MD",
      value: "MD"
    },
    {
      id: "degree-professional-13",
      group: "Professional",
      selectedTitle: "Professional - OD",
      title: "    OD",
      value: "OD"
    },
    {
      id: "degree-professional-14",
      group: "Professional",
      selectedTitle: "Professional - PharmD",
      title: "    PharmD",
      value: "PharmD"
    }
  ]
}